import type { FeatureManifest } from '../registry.js';
import { teamMemo } from './cache.js';
import { TeamIcon } from './icon.js';

/**
 * CP-02 Market Teams (SCR-12): browse / search / create, join (open) or ask to join
 * (invite-only), team home with members, preset chat and team help. The badge counts join
 * requests to answer and help requests the player can fill; a silent once-per-session refresh
 * keeps it current (and says when an invite-only request was accepted).
 */
export default {
  id: 'teams',
  flag: 'teams',
  unlock: 'teams',
  online: true,
  art: ['teams', 'rare', 'pip_extra'],
  provides: ['teams', 'teamCreate', 'teamPreview', 'teamMember', 'teamConfirm', 'teamHelpAsk'],
  entry: { order: 3.5, icon: TeamIcon, label: 'feature.teams.rail', testId: 'rail-teams', open: 'teams', badge: (a) => teamMemo(a).badge || null },
  mapOrder: 45,
  mapDue: (a) => {
    if (a.services.sync.status === 'offline' || a.session.checked.has('teams')) return false;
    const m = teamMemo(a);
    return m.teamId !== null || m.requested.length > 0;
  },
  load: () => import('./index.js'),
} satisfies FeatureManifest;
